// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyC7R7Sup9bm1zAUWRW5oTq35U512cJreak",
  authDomain: "galacticbarn-prod.firebaseapp.com",
  projectId: "galacticbarn-prod",
  storageBucket: "galacticbarn-prod.firebasestorage.app",
  messagingSenderId: "1024290898151",
  appId: "1:1024290898151:web:635e0e8182668bc3dc6242",
  measurementId: "G-V6R66E47FZ"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);